import { render, staticRenderFns } from "./ManteCartaCategoria.vue?vue&type=template&id=0a770693&"
import script from "./ManteCartaCategoria.vue?vue&type=script&lang=js&"
export * from "./ManteCartaCategoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports